import { number, numeric, string } from 'vue-mc/validation'
import BaseModel from '@/models/BaseModel'

export default class Sale extends BaseModel {
  defaults () {
    return {
      _id: null,
      order: null,
      total: null,
      customer: {
        phone: null
      },
      address: {},
      payments: []
    }
  }

  options () {
    return {
      identifier: '_id'
    }
  }

  getDefaultMethods () {
    return {
      fetch: 'GET',
      save: 'POST',
      update: 'PUT',
      create: 'POST',
      patch: 'PUT',
      delete: 'DELETE'
    }
  }

  validation () {
    return {
      total: [number.or(numeric)],
      'customer.phone': [string],
      status: [string]
    }
  }

  shouldPatch () {
    return true
  }

  routes () {
    return {
      fetch: `${this.API_BASE}/v1/sales`,
      save: `${this.API_BASE}/v1/sales`,
      patch: `${this.API_BASE}/v1/sales/{_id}`,
      delete: `${this.API_BASE}/v1/sales/{uuid}`
    }
  }
}
